import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  label: {
    marginBottom: 4,
    color: theme.palette.text.primary,
  },
}));
